import { Component, type ReactNode } from 'react';
import { Button, Result } from 'antd';

type Props = { children: ReactNode; resetKey: string };

/**
 * Keeps Hub on screen when a page fails (most often a page file that did not load on a weak
 * connection). Without it React removes the whole app, including the new-order alerts. Moving to
 * another page (`resetKey`, the path) tries again; pages are never remounted otherwise.
 */
export class PageErrorBoundary extends Component<Props, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override componentDidUpdate(previous: Props) {
    if (this.state.failed && previous.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <Result
        status="warning"
        title="This page didn't load"
        subTitle="Check the internet connection, then reload. New order alerts keep working."
        extra={
          <Button type="primary" size="large" onClick={() => window.location.reload()}>
            Reload
          </Button>
        }
      />
    );
  }
}
